import { render, staticRenderFns } from "./guideStock.vue?vue&type=template&id=04c4f577&scoped=true"
import script from "./guideStock.vue?vue&type=script&lang=js"
export * from "./guideStock.vue?vue&type=script&lang=js"
import style0 from "./guideStock.vue?vue&type=style&index=0&id=04c4f577&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c4f577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c4f577')) {
      api.createRecord('04c4f577', component.options)
    } else {
      api.reload('04c4f577', component.options)
    }
    module.hot.accept("./guideStock.vue?vue&type=template&id=04c4f577&scoped=true", function () {
      api.rerender('04c4f577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/guideStock.vue"
export default component.exports